import { useEffect } from 'react';
import './woff2/pretendard.css';
import 'react-loading-skeleton/dist/skeleton.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
  BrowserRouter,
  Route,
  Routes,
  useSearchParams,
} from 'react-router-dom';
import { ROUTER_PATHS } from './routes/routes.constatns';
import ReservationPage from './pages/reservation/ReservationPage/ReservationPage';
import NotFoundPage from './pages/common/NotFoundPage';
import BaseLayout from './shared/components/layout/BaseLayout';
import { LanguageCode } from './store/useLanguageCodeStore';
import strings from './constants/strings.constants';
import TreatmentReservationPage from './pages/reservation/TreatmentReservationPage/TreatmentReservationPage';
import AuthChecker from './components/AuthChecker';
import ReservationCompletePage from './pages/reservation/ReservationCompletePage/ReservationCompletePage';
import Modal from 'react-modal';
import ReservationHistoriesPage from './pages/reservation/ReservationHistoriesPage/ReservationHistoriesPage';
import Alert from './components/components/Alert';
import useAlertStore from './store/useAlertStore';
import useLanguageCodeStore from './store/useLanguageCodeStore';
import ReservationLandingPage from './pages/reservation/ReservationLandingPage/ReservationLandingPage';
import ChatRequestPage from './pages/ai-codi/ChatRequestPage/ChatRequestPage';
import AddReviewV2Page from './pages/review/AddReviewV2Page/AddReviewV2Page';
import { getLanguageCode } from './utils/utils';
import moment from 'moment';
import AfterNoticePage from './pages/reservation/AfterNoticePage/AfterNoticePage';
import ShortUrlRedirectPage from './pages/ShortUrlRedirectPage';
import { setGAUserProperties } from './utils/ga';
import { syncAppKeyboardInset } from './shared/utils/syncAppKeyboardInset';

const queryClient = new QueryClient();

function Root() {
  const [searchParams] = useSearchParams();
  const [setLanguageCode] = useLanguageCodeStore((state) => [
    state.setLanguageCode,
  ]);
  const treatmentAutoSelect = searchParams.get('treatmentAutoSelect');
  const partnerId = searchParams.get('partnerId');

  useEffect(() => {
    const langCode = searchParams.get('lang');
    if (langCode) {
      const mappedCode = getLanguageCode(langCode);
      console.log('mappedCode', mappedCode);
      strings.setLanguage(mappedCode);
      setLanguageCode(mappedCode);
      if (mappedCode === LanguageCode.zh) {
        moment.locale('zh-cn');
      } else {
        moment.locale(mappedCode);
      }
    } else {
      strings.setLanguage(LanguageCode.ko);
      setLanguageCode(LanguageCode.ko);
      moment.locale('ko');
    }
    // strings.setLanguage("en");
  }, [searchParams, setLanguageCode]);

  useEffect(() => {
    setGAUserProperties({
      partner_id: partnerId,
      source: 'mimo-web',
    });
  }, [partnerId]);

  return (
    <Routes>
      <Route
        path={ROUTER_PATHS.CONSULTING_RESERVATION}
        element={
          <AuthChecker>
            <BaseLayout>
              <ReservationPage
                reservationType="CONSULTING"
                treatmentAutoSelect={treatmentAutoSelect === 'true'}
              />
            </BaseLayout>
          </AuthChecker>
        }
      />
      <Route
        path={ROUTER_PATHS.EVENT_TREATMENT_RESERVATION}
        element={
          <AuthChecker>
            <BaseLayout>
              <TreatmentReservationPage />
            </BaseLayout>
          </AuthChecker>
        }
      />
      <Route
        path={ROUTER_PATHS.REVISIT_RESERVATION}
        element={
          <AuthChecker>
            <BaseLayout>
              <ReservationPage reservationType="REVISIT" />
            </BaseLayout>
          </AuthChecker>
        }
      />
      <Route
        path={ROUTER_PATHS.TREATMENT_RESERVATION}
        element={
          <AuthChecker>
            <BaseLayout>
              <ReservationPage reservationType="TREATMENT" />
            </BaseLayout>
          </AuthChecker>
        }
      />
      <Route
        path={ROUTER_PATHS.REVIEW}
        element={
          <BaseLayout>
            <AddReviewV2Page />
          </BaseLayout>
        }
      />
      <Route
        path={ROUTER_PATHS.RESERVATION_COMPLETE}
        element={
          <BaseLayout>
            <ReservationCompletePage />
          </BaseLayout>
        }
      />
      <Route
        path={ROUTER_PATHS.RESERVATION_HISTORIES}
        element={
          <AuthChecker>
            <BaseLayout>
              <ReservationHistoriesPage />
            </BaseLayout>
          </AuthChecker>
        }
      />
      <Route
        path={ROUTER_PATHS.RESERVATION}
        element={
          <AuthChecker>
            <BaseLayout>
              <ReservationLandingPage />
            </BaseLayout>
          </AuthChecker>
        }
      />
      <Route
        path={ROUTER_PATHS.EVENT_TREATMENT_RESERVATION}
        element={
          <AuthChecker>
            <BaseLayout>
              <TreatmentReservationPage />
            </BaseLayout>
          </AuthChecker>
        }
      />
      <Route
        path={ROUTER_PATHS.AFTER_NOTICES}
        element={
          <AuthChecker>
            <BaseLayout>
              <AfterNoticePage />
            </BaseLayout>
          </AuthChecker>
        }
      />

      <Route
        path={ROUTER_PATHS.CHAT_REQUEST}
        element={
          <AuthChecker>
            <BaseLayout>
              <ChatRequestPage />
            </BaseLayout>
          </AuthChecker>
        }
      />
      <Route
        path={ROUTER_PATHS.SHORT_URL_REDIRECT}
        element={<ShortUrlRedirectPage />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

Modal.setAppElement('#root');

function App() {
  const { onConfirm, message, visible, showCancelButton } = useAlertStore();

  useEffect(() => syncAppKeyboardInset(), []);

  return (
    <QueryClientProvider client={queryClient}>
      {visible && (
        <Alert
          title={message}
          onConfirm={onConfirm}
          showCancelButton={showCancelButton}
        />
      )}
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
